import { render, staticRenderFns } from "./bannerCreate.vue?vue&type=template&id=c997b606&scoped=true&lang=html"
import script from "./bannerCreate.vue?vue&type=script&lang=js"
export * from "./bannerCreate.vue?vue&type=script&lang=js"
import style0 from "./bannerCreate.vue?vue&type=style&index=0&id=c997b606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997b606",
  null
  
)

export default component.exports